<!--构件上传-->
<template>
  <div id="ListUploader" ref="ListUploader" class="uploader">
    <el-dialog
      :visible.sync="modalVisible"
      :close-on-click-modal="false"
      width="1000px"
      custom-class="uploader-dialog"
      append-to-body
      @open="dialogOpen"
      @close="handleCancel"
    >
      <div slot="title">
        <span v-if="operate === 'renewal'">
          <span class="dialog-title">更新</span>
          <span class="ft-12">“{{ renewalObj.name }}”</span>
        </span>
        <span v-else class="dialog-title">上传{{ resourceCn }}</span>
      </div>
      <div class="files-container">
        <!--上传-->
        <el-upload
          ref="upload"
          class="drag-uploader"
          action="#"
          drag
          :multiple="operate !== 'renewal'"
          :http-request="preUpload"
          :on-change="fileChange"
          :file-list="selectFile"
          :accept="allowTypes"
          :show-file-list="false"
          :auto-upload="false"
          :limit="100"
          :on-exceed="onExceed"
        >
          <i class="el-icon-upload" />
          <div v-if="envPlatform === 'web'" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div v-else class="el-upload__text">点击上传文件</div>
          <div slot="tip" class="el-upload__tip">
            <span>当前支持上传的文件类型: {{ allowTypes }}文件</span>
            <span v-show="fileTable.length">{{ selectCount }} / {{ tableTotal }}</span>
          </div>
        </el-upload>
        <div v-if="fileTable.length">
          <el-table
            ref="multipleTable"
            :data="fileTable"
            style="width: 100%"
            max-height="300"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50" :selectable="canSelect" v-if="operate !== 'renewal'"/>
            <el-table-column prop="name" label="文件名" show-overflow-tooltip />
            <el-table-column prop="size" label="文件大小" width="84px" :formatter="fmtSize" />
            <el-table-column v-if="customColumns.appName" prop="appName" label="适配软件" show-overflow-tooltip>
              <template v-slot="scope">
                <ul v-if="scope.row.softwares">
                  <li v-for="software in scope.row.softwares" :key="software.softwareCode">{{ getMatchedApp(software) }}</li>
                </ul>
                <span v-else>{{ getMatchedApp(scope.row) || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="customColumns.placeholderType" label="图例类型" width="80">
              <template v-slot="scope">
                <span>{{ scope.row.disciplineStr }}-{{ scope.row.placeholderTypeStr }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="customColumns.classify" label="上传至">
              <template v-slot="scope">
                <classify-select
                  v-if="(scope.row.spaceCategoryId||scope.row.spaceCategoryId===0)"
                  :options-tree="spaceClassifyTree"
                  :init-value="getSpaceClassifyIdPath(scope.row.spaceCategoryId)"
                  :prop-obj="propObj"
                  @selected="val=>changeClassify(val,scope.row)"
                />
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column v-if="customColumns.validation" label="校验" width="94px">
              <template v-slot="scope">
                <span :class="validFileClass(scope.row)">{{ scope.row.validatedText }}</span>
              </template>
            </el-table-column>
          </el-table>
          <template>
            <div class="uploader-tip mg-top-sm">注: 1、上传过程中请勿刷新或切换页面，否则可能会导致上传数据丢失；</div>
            <div class="uploader-tip" v-if="resourceType === 'COMPONENT' && platform === 'NOVA_DESIGN'" >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、构件需进行解析，请耐心等待，仅支持数维2024_1230及以上的构件解析，若为低版本构件请先升级至2024_1230及以上版本后再上传。
            </div>
            <div class="uploader-tip" v-else-if="resourceType === 'COMPONENT' && platform === 'REVIT'">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、资源需进行解析，请耐心等待，仅支持Revit2016~2023的构件解析。
            </div>
            <div class="uploader-tip" v-else-if="resourceType === 'SCHEME' && platform === 'NOVA_DESIGN'">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、仅支持数维2025.630及以上的模板解析，若为低版本模板请先升级后再上传。
            </div>
            <div class="uploader-tip mg-top-sm" v-else></div>
          </template>
        </div>
      </div>
      <template slot="footer">
        <div v-if="fileTable.length" class="footer">
          <div class="footer-oper">
            <el-button key="back" @click="handleCancel">取消</el-button>
            <el-button
              key="submit"
              type="primary"
              :disabled="!selectFile.length"
              :loading="loading"
              @click="handleOk"
            >{{ operate === 'renewal' ? '开始更新' : '开始上传' }}</el-button>
          </div>
        </div>
        <div v-else />
      </template>
    </el-dialog>
    <!--上传列表-->
    <div class="upload-list" :class="{'list-fold':isFold}">
      <div class="upload-list-header">
        <span>任务列表（{{ overCount }}/{{ uploadTotal }}）</span>
        <span class="rotate-control" @click="isFold = !isFold">
          <i class="gjw-iconfont gjw-icon-fold rotate-icon" :class="{'icon-fold':isFold}" />
        </span>
      </div>
      <div v-show="!isFold" class="upload-list-content">
        <div v-show="!isFold" class="tabs">
          <div class="tab-item" :class="{'active': activeTab === 'upload'}" @click="showList('upload')">上传<span class="total">{{ uploadList.length }}</span></div>
          <div class="tab-item" :class="{'active': activeTab === 'renewal'}" @click="showList('renewal')">更新<span class="total">{{ renewalList.length }}</span></div>
          <div v-if="$route.name ==='ComponentList'" class="tab-item" :class="{'active': activeTab === 'downgrades'}" @click="showList('downgrades')">降级<span class="total">{{ downgradesList.length }}</span></div>
        </div>
        <!--上传列表-->
        <div v-if="activeTab === 'upload'" key="upload" class="file-list">
          <ul v-if="uploadList.length">
            <li v-for="(file,index) in uploadList" :key="index" class="file">
              <span class="name ellipsis-text">{{ file.name }}</span>
              <span class="size ellipsis-text">{{ fmtSize(file) }}</span>
              <span class="progress">
                <el-progress :percentage="file.uploadProgress" :show-text="false" :color="customColor(file)" />
              </span>
              <span v-if="file.uploadStatus==='success'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />上传成功</span>
              <span v-if="file.uploadStatus==='updateSuccess'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />更新成功</span>
              <span v-if="file.uploadStatus==='waiting'" class="status-span waiting"><i class="gjw-iconfont gjw-icon-icon_wait" />等待上传</span>
              <span v-if="file.uploadStatus==='uploading'" class="status-span uploading"><i class="gjw-iconfont gjw-icon-icon_wait" />正在上传</span>
              <span v-if="file.uploadStatus==='fail'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />上传失败</span>
              <span v-if="file.uploadStatus==='existed'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />资源已存在</span>
              <span v-if="file.uploadStatus==='fileExisted'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />文件已存在</span>
            </li>
          </ul>
          <div v-else class="empty-content">暂无数据</div>
        </div>
        <!--更新列表-->
        <div v-if="activeTab === 'renewal'" key="renewal" class="file-list">
          <ul v-if="renewalList.length">
            <li v-for="(file,index) in renewalList" :key="index" class="file">
              <span class="name ellipsis-text">{{ file.renewalName }}</span>
              <span class="size ellipsis-text">{{ fmtSize(file) }}</span>
              <span class="progress">
                <el-progress :percentage="file.uploadProgress" :show-text="false" :color="customColor(file)" />
              </span>
              <span v-if="file.uploadStatus==='success'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />更新成功</span>
              <span v-if="file.uploadStatus==='waiting'" class="status-span waiting"><i class="gjw-iconfont gjw-icon-icon_wait" />等待更新</span>
              <span v-if="file.uploadStatus==='uploading'" class="status-span uploading"><i class="gjw-iconfont gjw-icon-icon_wait" />正在更新</span>
              <span v-if="file.uploadStatus==='notExisted'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />资源不存在</span>
              <span v-if="file.uploadStatus==='fail'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />更新失败</span>
              <span v-if="file.uploadStatus==='md5Duplicate'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />资源文件重复</span>
              <span v-if="file.uploadStatus==='versionMismatch'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />版本不匹配</span>
            </li>
          </ul>
          <div v-else class="empty-content">暂无数据</div>
        </div>
        <!--降级列表-->
        <div v-if="activeTab === 'downgrades'" key="downgrades" class="file-list">
          <ul v-if="downgradesList.length">
            <li v-for="(file,index) in downgradesList" :key="index" class="file">
              <span class="name ellipsis-text">{{ file.name }}</span>
              <span class="size ellipsis-text"></span>
              <span class="progress">
                <el-progress :percentage="file.uploadProgress" :show-text="false" :color="customColor(file)" />
              </span>
              <span v-if="file.status==='success'" class="status-span success"><i class="gjw-iconfont gjw-icon-done" />降级成功</span>
              <span v-if="file.status==='waiting'" class="status-span waiting"><i class="gjw-iconfont gjw-icon-icon_wait" />等待降级</span>
              <span v-if="file.status==='processing'" class="status-span uploading"><i class="gjw-iconfont gjw-icon-icon_wait" />正在降级</span>
              <span v-if="file.status==='notExisted'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />资源不存在</span>
              <span v-if="file.status==='fail'" class="status-span error"><i class="gjw-iconfont gjw-icon-icon_attention" />降级失败</span>
            </li>
          </ul>
          <div v-else class="empty-content">暂无数据</div>
        </div>
        <div class="uploader-tip upload-content-tip">注：文件处理过程中请勿刷新或切换页面，以免数据丢失。</div>
      </div>
    </div>
  </div>
</template>

<script>
import classifySelect from '@/components/business/resource/classifySelect.vue'
import { RegSymbol } from '@/core/RegExp'
import Tools from '@/core/tools'
import Utils from '@/core/utils'
import MixinMatchCategory from '@/mixins/MixinMatchCategory'
import Upload from '@/core/upload'
import Queue from '@/core/queue'
import { getResourceType, getSoftwareCn } from '@/assets/js/resourceMap.js'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ListUpload',
  components: {
    classifySelect
  },
  mixins: [MixinMatchCategory],
  props: {
    resourceType: {
      type: String,
      default: 'COMPONENT'
    },
    hasRenewal: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: null
    },
    renewalObj: {
      type: Object,
      default() {
        return {}
      }
    },
    allowTypes: { // 允许上传的文件格式
      type: String,
      default: '.gac'
    },
    softwareVersion: [String, Number],
    softwareCode: [String, Number],
    language: String,
    fileTableColumns: {
      type: Object,
      default() {
        return {}
      }
    },
    highestVersion: {
      type: String,
      default: null
    },
    // 上传至 的 所有分类来源
    spaceClassifyTree: {
      type: Array,
      default() {
        return []
      }
    },
    // 用户选中的分类
    spaceCategoryId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      upQueue: new Queue(5, this.uploading, this.uploadWait),
      RegSymbol,
      modalVisible: false,
      loading: false,
      fileTable: [], // 所有等待上传的文件
      selectFile: [], // 已勾选的文件
      isFold: true, // 是否收起状态
      // 上传文件列表
      uploadList: [],
      // 更新文件列表
      renewalList: [],
      // 降级文件列表
      downgradesList: [],
      activeTab: 'upload',
      tagIds: [],
      tagNames: '',
      operate: 'upload', // 操作类型：upload / renewal
      loadingInstance: {},
      spaceId: this.$route.params.spaceId
    }
  },
  computed: {
    ...mapGetters({
      envPlatform: 'platform',
      softwareVersionNameMap: 'common/softwareVersionNameMap',
    }),
    uploadTableData() {
      return [...this.uploadList, ...this.renewalList, ...this.downgradesList]
    },
    tableTotal() {
      return this.fileTable.length
    },
    selectCount() {
      return this.selectFile.length
    },
    uploadTotal() {
      return this.uploadTableData.length || 0
    },
    overCount() {
      const arr = this.uploadTableData.filter((file) => {
        return file.uploadStatus !== 'uploading' && file.uploadStatus !== 'waiting' && file.status !== 'processing'
      })
      return arr.length || 0
    },
    resourceCn() {
      return getResourceType(this.resourceType)
    },
    customColumns() {
      return {
        appName: false,
        softwareClassify: false,
        placeholderType: false,
        classify: false,
        validation: false,
        ...this.fileTableColumns
      }
    },
    isCapitalSoftware() {
      return ['AppGbr', 'AppGroad'].includes(this.softwareCode)
    },
    needParseDesignFile() {
      return this.resourceType === 'COMPONENT' && this.platform === 'NOVA_DESIGN'
    },
    // gmd、gmed文件
    needParseGmdFile() {
      return this.resourceType === 'MODULE' && this.platform === 'NOVA_DESIGN'
    },
    // gnbt文件
    needParseGnbtFile() {
      return this.resourceType === 'SCHEME' && this.platform === 'NOVA_DESIGN'
    },
    comparingVersion() {
      return this.softwareVersion
    },
    propObj() {
      return {
        label: 'name',
        value: 'id',
        children: 'children',
        // 是否可以选择任意一级
        checkStrictly: true
      }
    }
  },
  methods: {
    ...mapGetters({
      getSpaceClassifyIds: 'classifySpace/getSpaceClassifyIds'
    }),
    ...mapActions({
      loadSoftwareVersionNameMap: 'common/loadSoftwareVersionNameMap'
    }),
    showModal(operate) {
      this.operate = operate
      this.modalVisible = true
      this.fileTable = []
      this.selectFile = []
      this.loadSoftwareVersionNameMap({ space_id: this.$route.params.spaceId, software_code: this.softwareCode })
    },
    showUploadList(operate, componentObj) {
      this.activeTab = operate
      this.isFold = false
      this.downgradesList.push({
        ...componentObj,
        uploadProgress: 0
      })
      this.downgradesList.forEach((item) => {
        if (item.status === 'processing') {
          item.timerId = this.incrementProgress(item)
        }
      })
    },
    incrementProgress(item) {
      if (item.uploadProgress < 100) {
        const increment = 2
        setTimeout(async () => {
          if (item.uploadProgress < 100) {
            const result = await this.$api.resource.getDowngradesInfo(this.spaceId, item.id)
            if (result.status === 'success') {
              // 重新查一遍降级的信息，成功的话清除定时器
              clearInterval(item.timerId)
              item.timerId = null

              const index = this.downgradesList.findIndex((c) => c.id === item.id)
              if (index !== -1) {
                const updatedItem = { ...this.downgradesList[index], ...result, uploadProgress: 100 }
                this.$set(this.downgradesList, index, updatedItem)
              }

              // 发送通知，列表更新
              this.$emit('updateList')
              return
            }
            item.uploadProgress < 90 && (item.uploadProgress += increment)
            this.incrementProgress(item)
          }
        }, 2000)
      }
    },
    dialogOpen() {
      /** 由于这些参数涉及到业务接口传参, 所以不能在关闭的时候立即重置为默认值，故需要在打开dialog的时候再重置 **/
      this.fileTable = []
      this.selectFile = []
    },
    // 根据软件code和软件版本查找软件版本名称
    getSoftwareVersionName() {
      const names = this.softwareVersionNameMap || []
      const softwareObj = names.find((item) => {
        return item.softwareCode === this.softwareCode && item.softwareVersion === this.softwareVersion
      }) || {}
      return softwareObj.versionName || this.softwareVersion
    },
    // 模板的校验、解析、上传方法
    schemeMethods() {
      return {
        valid: (file) => {
          if (file.appName !== this.softwareCode) {
            file.validatedText = '软件不匹配'
            return false
          } else if (!file.appVersion) {
            file.validatedText = '版本过低'
            return false
          } else if (!Utils.isHigherVersion(file.appVersion, '2.6')) {
            file.validatedText = '版本过低'
            return false
          } else if (this.operate === 'renewal' && file.appVersion.toString() !== this.renewalObj.softwareVersion) {
            file.validatedText = '版本不匹配'
            return false
          }
          file.validatedText = '校验通过'
          return true
        },
        uploadStart: async() => {
          this.loading = true
          this.selectFile.forEach((file) => {
            file.uploadProgress = 0
            file.uploadStatus = 'waiting'
            file.softwareCode = file.appName || this.softwareCode
            // file.softwareVersion = this.operate === 'renewal' ? file.softwareVersion : this.softwareVersion
            file.language = this.language
            // 标记该文件是上传还是更新的文件
            file.operate = this.operate
            const targetArr = this.operate === 'upload' ? this.uploadList : this.renewalList
            targetArr.push(file)
          })
          await this.$refs.upload.submit()
          this.$refs.upload && this.$refs.upload.clearFiles()
          this.loading = false
          this.modalVisible = false
          this.isFold = false
          this.activeTab = this.operate
          this.tagIds = []
          this.tagNames = ''
        },
        parseFile: async(file) => {
          /**
           * 解析并获取gnbt文件中的软件信息，并截取主版本信息**/
          const [originFileObj] = await Promise.all([this.$getGmdJson(file.raw)])
          if (!originFileObj.application_type) {
            // 无meta.json文件，需提示版本过低，所以手动将软件改为桥梁
            file.appName = 'AppGbr'
            file.softwareName = getSoftwareCn('AppGbr')
            return
          }
          const appNameMap = {
            // 桥梁
            GNB: 'AppGbr',
          }
          const softwareInfo = {
            fileAppName: appNameMap[originFileObj.application_type],
            fileAppVersion: `${originFileObj.application_version_first}.${originFileObj.application_version_second}`
          }
          if (this.renewalObj && this.renewalObj.id) {
            // 更新时，需要用软件版本及空间资源id
            file.softwareVersionId = this.renewalObj.id
            file.spaceResourceId = this.renewalObj.spaceResourceId
            file.spaceId = this.renewalObj.spaceId
            file.renewalName = this.renewalObj.name
          }
          const appName = softwareInfo.fileAppName
          const version = softwareInfo.fileAppVersion
          // 后端接口softwareVersionNameMap获取后
          const versionObj = this.softwareVersionNameMap.find((item) => item.displayVersion === version) || {}
          if (appName) {
            file.appName = appName
            file.softwareName = getSoftwareCn(appName)
          }
          if (version) {
            file.appVersion = versionObj.softwareVersion || version
            file.softwareVersionName = versionObj.displayVersion
            file.softwareVersion = versionObj.softwareVersion
          }
          file.spaceCategoryId = this.spaceCategoryId
          file.md5 = await this.$getMd5(file.raw)
        }
      }
    },
    // 不同类型资源验证、解析、开始上传
    getSpecialMethod() {
      if (this.needParseDesignFile) {
        return {
          valid: (file) => {
            const res = true
            if (this.operate === 'renewal') { // 更新
              if (!this.isSameSoftwareList(file.appNames, this.renewalObj.softwareList)) {
                file.validatedText = '软件不一致'
                return false
              }
              if (file.appVersion !== this.renewalObj.softwareVersion) {
                file.validatedText = '版本不一致'
                return false
              }
            } else {
              if (!file.appNames.includes(this.softwareCode)) {
                file.validatedText = '软件不匹配'
                return false
              } else if (file.appVersion > this.comparingVersion) {
                file.validatedText = '版本过高'
                return false
              } else if (file.appVersion < 0.45) {
                file.validatedText = '版本过低'
                return false
              }
            }
            file.validatedText = '校验通过'
            return res
          },
          uploadStart: async() => {
            this.loading = true
            this.selectFile.forEach((file) => {
              file.uploadProgress = 0
              file.uploadStatus = 'waiting'
              // 标记该文件是上传还是更新的文件
              file.operate = this.operate
              file.softwareCode = file.appName || this.softwareCode
              file.language = this.language
              file.tagIds = this.tagIds
              const targetArr = this.operate === 'upload' ? this.uploadList : this.renewalList
              targetArr.push(file)
            })
            await this.$refs.upload.submit()
            this.$refs.upload && this.$refs.upload.clearFiles()
            this.modalVisible = false
            this.loading = false
            this.isFold = false
            this.activeTab = this.operate
            this.tagIds = []
            this.tagNames = ''
          },
          parseFile: async(file) => {
            /**
           * 解析并获取gac文件中的分类id，匹配映射关系，获得分类名称
           * 解析并获取gac文件中的版本信息，并截取主版本信息**/
            const [FamilyParameters, versionObj] = await Promise.all([this.$getGacJson(file.raw), this.$getGacJson(file.raw, 'CustomData/component_editor_version.xml')])
            if (!FamilyParameters.Category || !versionObj.ProjectAppName) { return }
            const cid = FamilyParameters.Category._GUID
            if (this.resourceType === 'PLACEHOLDER') {
              const legendTypeInfo = Utils.getGacLegendType(FamilyParameters)
              file = Object.assign(file, legendTypeInfo)
            }
            versionObj.ProjectAppName = versionObj.ProjectAppName.endsWith(';') ? versionObj.ProjectAppName.slice(0, -1) : versionObj.ProjectAppName
            if (versionObj.ProjectAppName) {
              file.appName = versionObj.ProjectAppName
            }
            const appNames = versionObj.ProjectAppName.split(';') || []
            file.appNames = appNames
            const version = Utils.getMainVersion(versionObj.ProjectAppVersion)

            if (version) {
              file.appVersion = version
              file.softwareVersion = version
            }
            const softwareObjArr = []
            if (appNames && version) {
              const len = appNames.length
              for (let i = 0; i < len; i++) {
                const appName = appNames[i]
                const sobj = this.softwareVersionNameMap.find((item) => {
                  return item.softwareVersion === version
                }) || {}
                softwareObjArr.push({
                  appName,
                  appVersion: version,
                  softwareVersionName: sobj.displayVersion,
                })
              }
              file.softwares = softwareObjArr
            }
            if (cid && this.operate === 'upload') {
              file.editorCId = cid
              // 默认的上传至分类：行业是映射店铺分类得到，企业是用户选中传过来
              file.spaceCategoryId = this.spaceCategoryId
            }
            if (this.renewalObj && this.renewalObj.id) {
              // 更新时，需要用软件版本及空间资源id
              file.softwareVersionId = this.renewalObj.id
              file.spaceResourceId = this.renewalObj.spaceResourceId
              file.spaceId = this.renewalObj.spaceId
              file.renewalName = this.renewalObj.name
            }
            file.md5 = await this.$getMd5(file.raw)
          },
        }
      } else if (this.needParseGmdFile) {
        return {
          valid: (file) => {
            if (file.appName !== this.softwareCode) {
              file.validatedText = '软件不匹配'
              return false
            } else if (!file.appVersion) {
              file.validatedText = '版本信息缺失'
              return false
            } else if (this.operate === 'renewal' && file.appVersion.toString() !== this.renewalObj.softwareVersion) {
              file.validatedText = '版本不匹配'
              return false
            }
            file.validatedText = '校验通过'
            return true
          },
          uploadStart: async() => {
            this.loading = true
            this.selectFile.forEach((file) => {
              file.uploadProgress = 0
              file.uploadStatus = 'waiting'
              file.softwareCode = file.appName || this.softwareCode
              // file.softwareVersion = this.operate === 'renewal' ? file.softwareVersion : this.softwareVersion
              file.language = this.language
              // 标记该文件是上传还是更新的文件
              file.operate = this.operate
              const targetArr = this.operate === 'upload' ? this.uploadList : this.renewalList
              targetArr.push(file)
            })
            await this.$refs.upload.submit()
            this.$refs.upload && this.$refs.upload.clearFiles()
            this.loading = false
            this.modalVisible = false
            this.isFold = false
            this.activeTab = this.operate
            this.tagIds = []
            this.tagNames = ''
          },
          parseFile: async(file) => {
            /**
               * 解析并获取gmd文件中的软件信息，并截取主版本信息**/
            const [gmdObj] = await Promise.all([this.$getGmdJson(file.raw)])
            if (!gmdObj.application_type) { return }
            const gmdAppNameMap = {
              // 建筑
              gap: 'AppGarch',
              // 机电
              gmep: 'AppGmep',
              // 结构
              gst: 'AppGstr',
            }
            const softwareInfo = {
              fileAppName: gmdAppNameMap[gmdObj.application_type],
              fileAppVersion: `${gmdObj.application_version_first}.${gmdObj.application_version_second}`
            }
            if (this.renewalObj && this.renewalObj.id) {
              // 更新时，需要用软件版本及空间资源id
              file.softwareVersionId = this.renewalObj.id
              file.spaceResourceId = this.renewalObj.spaceResourceId
              file.spaceId = this.renewalObj.spaceId
              file.renewalName = this.renewalObj.name
            }
            const appName = softwareInfo.fileAppName
            const version = softwareInfo.fileAppVersion
            // 后端接口softwareVersionNameMap获取后
            const versionObj = this.softwareVersionNameMap.find((item) => item.softwareVersion === version) || {}
            if (appName) {
              file.appName = appName
              file.softwareName = getSoftwareCn(appName)
            }
            if (version) {
              file.appVersion = version
              file.softwareVersionName = versionObj.displayVersion
              file.softwareVersion = version
            }
            file.spaceCategoryId = this.spaceCategoryId
            file.md5 = await this.$getMd5(file.raw)
          }
        }
      } else if (this.needParseGnbtFile) {
        return this.schemeMethods()
      } else {
        return {
          valid: (file) => {
            if (this.operate === 'renewal' && this.renewalObj && this.renewalObj.id) {
              if (file.appName.toLowerCase() !== this.renewalObj.softwareCode.toLowerCase()) {
                file.validatedText = '软件不匹配'
                return false
              }
              if (this.renewalObj.softwareVersion && file.appVersion.toString() !== this.renewalObj.softwareVersion) {
                file.validatedText = '版本不匹配'
                return false
              }
            }
            file.validatedText = '校验通过'
            if (!file.appName && file.appName === '') {
              file.validatedText = '软件未能解析'
              return false
            }
            // Navisworks没有版本
            if (file.appName !== 'Navisworks' && !file.appVersion && file.appVersion === '') {
              file.validatedText = '版本未能解析'
              return false
            }
            return true
          },
          uploadStart: async() => {
            this.loading = true
            this.selectFile.forEach((file) => {
              file.uploadProgress = 0
              file.uploadStatus = 'waiting'
              // 标记该文件是上传还是更新的文件
              if (!(file.operate && file.operate === 'renewal')) {
                file.operate = this.operate
              }
              file.softwareCode = this.softwareCode
              file.language = this.language
              file.tagIds = this.tagIds
              const targetArr = file.operate === 'upload' ? this.uploadList : this.renewalList
              targetArr.push(file)
            })
            await this.$refs.upload.submit()
            this.$refs.upload && this.$refs.upload.clearFiles()
            this.loading = false
            this.modalVisible = false
            this.isFold = false
            this.activeTab = this.operate
            this.tagIds = []
            this.tagNames = ''
          },
          parseFile: async(file) => {
            const [versionObj] = await this.fileExtract(file)
            if (versionObj) {
              file.appName = versionObj.ProjectAppName ? versionObj.ProjectAppName : ''
              file.softwareCode = versionObj.ProjectAppName ? versionObj.ProjectAppName : ''
              file.appVersion = versionObj.ProjectAppVersion ? versionObj.ProjectAppVersion : ''
              file.softwareVersionName = versionObj.ProjectAppVersion ? versionObj.ProjectAppVersion : ''
              file.softwareVersion = versionObj.ProjectAppVersion ? versionObj.ProjectAppVersion : ''
            } else {
              file.appName = '-'
            }
            if (this.renewalObj && this.renewalObj.id) {
              // 更新时，需要用软件版本及空间资源id
              file.softwareVersionId = this.renewalObj.id
              file.spaceResourceId = this.renewalObj.spaceResourceId
              file.spaceId = this.renewalObj.spaceId
              file.renewalName = this.renewalObj.name
            }
            file.spaceCategoryId = this.spaceCategoryId
            file.md5 = await this.$getMd5(file.raw)
          }
        }
      }
    },
    async fileExtract(file) {
      const fileSuffixs = file.name.split('.').slice(-1)
      const fileSuffix = fileSuffixs.length ? fileSuffixs[0] : ''
      if (['rfa', 'rte', 'rvt'].includes(fileSuffix)) {
        return await Promise.all([this.$getRevitJson(file.raw, fileSuffix)])
      } else if (['dwg', 'dxf'].includes(fileSuffix)) {
        return await Promise.all([this.$getCADJson(file.raw, fileSuffix)])
      } else if (['gap', 'gmep', 'gst', 'gapc', 'gmepc', 'gstc'].includes(fileSuffix)) {
        return await Promise.all([this.$getGModelJson(file.raw, fileSuffix)])
      } else if (['nwd'].includes(fileSuffix)) {
        return [{ ProjectAppName: 'Navisworks' }]
      }
      return await Promise.all([])
    },
    fmtSize(file) {
      return Tools.fmtSize(file.size)
    },
    getSpaceClassifyIdPath(id) {
      return this.getSpaceClassifyIds()(id)
    },
    showList(tab) {
      this.activeTab = tab
    },
    handleCancel() {
      this.modalVisible = false
      this.tagIds = []
      this.tagNames = ''
    },
    handleOk() {
      this.uploadStart()
    },
    // 更新文件状态、进度条等
    updateFile(file, newOpts) {
      const targetArr = file.operate === 'upload' ? this.uploadList : this.renewalList
      targetArr.forEach((item, index) => {
        if (item.uid === file.uid) {
          item = { ...item, ...newOpts }
          targetArr.splice(index, 1, item)
        }
      })
    },
    // 开始上传流程
    async uploadStart() {
      if (this.operate === 'renewal') {
        const { softwareVersionId, md5, spaceResourceId, spaceId } = this.selectFile[0]
        await this.$api.resource.checkMD5(spaceId, spaceResourceId, softwareVersionId, md5).then((data) => {
          if (data) {
            this.$message.error(`与当前资源重复，无需更新`)
            return false
          } else {
            this.getSpecialMethod().uploadStart()
          }
        }).catch((err) => {
          this.$message.error(err)
          return false
        })
      } else {
        await this.getSpecialMethod().uploadStart()
      }
    },
    // 检验文件
    validFileInfo(file) {
      return this.getSpecialMethod().valid(file)
    },
    validFileClass(file) {
      return this.validFileInfo(file) ? file.validatedText === '存在重名文件' ? 'yellow' : 'green' : 'red'
    },
    // 上传文件列表变化后
    fileListChange(file, fileList) {
      if (this.fileTable.find((it) => { return it.name === file.name })) {
        this.$message.error('文件名称重复，已自动删除重名文件')
        // 为了使fileList.length与this.fileTable.length保持一致，从而关闭全局loading
        const index = fileList.findIndex((it) => { return it.uid === file.uid })
        fileList.splice(index, 1)
        return
      }
      if (!this.spaceCategoryId) {
        this.$message.error('请选择需上传的目录')
        return
      }
      this.fileChangeValid(file)
    },
    async fileChangeValid(file) {
      const valid = this.validFileInfo(file)
      this.fileTable.push(file)
      const length = this.fileTable.length
      if (valid) {
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(this.fileTable[length - 1])
        })
      }
    },
    // 进度条颜色
    customColor(row) {
      switch (row.uploadStatus || row.status) {
        case 'success': return '#52C41A'
        case 'updateSuccess':return '#52C41A'
        case 'uploading': return '#1890FF'
        case 'waiting': return '#FF9E50'
        case 'fail': return '#BFBFBF'
        case 'md5Duplicate': return '#BFBFBF'
        case 'versionMismatch': return '#BFBFBF'
        case 'existed':return '#BFBFBF'
      }
    },
    // 上传成功
    uploadSuccess(file) {
      this.updateFile(file, { uploadProgress: 100 })
      if (file.storeId) {
        this.$emit('success', { file, id: file.storeId })
      } else {
        this.uploadError(file)
      }
    },
    // 上传失败
    uploadError(file) {
      this.updateFile(file, { uploadStatus: 'fail' })
    },
    // 勾选上传的文件后
    handleSelectionChange(val) {
      this.selectFile = val
    },
    // 判断文件是否可勾选
    canSelect(row) {
      return this.validFileInfo(row)
    },
    getMatchedApp({ appName, appVersion, softwareName, softwareVersionName }) {
      return `${softwareName || getSoftwareCn(appName) || appName}${(softwareVersionName || appVersion) ? '_' : ''}${softwareVersionName || appVersion || ''}`
    },
    changeClassify(value, row) {
      row.spaceCategoryId = value
    },
    // 检查文件
    checkFile(file) {
      const size = file.size
      if (!size) {
        this.$message.error(`文件内容为空，已自动删除不符合的文件`)
        return false
      }
      const allowTypes = this.allowTypes.split(',')
      const arr = file.name.split('.')
      const type = '.' + arr[arr.length - 1].toLowerCase()
      const isType = allowTypes.indexOf(type) > -1
      if (!isType) {
        this.$message.error(`文件格式有误，已自动删除不符合的文件`)
        return false
      }
      const isNameInvalid = this.RegSymbol.test(file.name)
      if (isNameInvalid) {
        this.$message.error(`文件名中含禁用字符，已自动删除不合规文件`)
        return false
      }
      return true
    },
    onExceed() {
      this.$message.error('单次上传文件数不能大于100个，请分批上传.')
    },
    // 文件列表变化
    async fileChange(file, fileList) {
      try {
        // 点击上传时，仍会走到这里，所以增加判断this.loading为true时，不显示fullLoading
        if (!this.loading && this.fileTable.length !== fileList.length) {
          this.$fullLoading.open('解析中，请稍后...')
        }
        if (this.operate === 'renewal' && fileList.length) {
          fileList = file
          this.fileTable = []
          this.selectFile = []
        }
        if (file.status === 'ready') {
          if (!this.checkFile(file)) {
            const index = fileList.findIndex((x) => { return x.uid === file.uid })
            fileList.splice(index, 1)
            return
          }
          await this.getSpecialMethod().parseFile(file)
          file.md5 = await this.$getMd5(file.raw)
          this.fileListChange(file, fileList)
        }
        if (this.fileTable.length === fileList.length) {
          this.$fullLoading.close()
        }
      } finally {
        if (this.fileTable.length === fileList.length || file.status === 'success' || this.renewalObj.suffix) {
          this.$fullLoading.close()
        }
      }
    },
    /**
         * 准备上传文件：
         * 如果上传中的文件数量uploadingCount < 最大可上传的数量maxUploadingCount，则调用uploading（）直接上传
         * 否则，加入uploadQueue队列，等待上传*/
    async preUpload(payload) {
      const payloadFile = payload.file ? payload.file : payload
      const file = this.selectFile.find((f) => f.uid === payloadFile.uid && f.uploadStatus !== 'fail')
      if (file) {
        this.upQueue.preDo(file)
      }
    },
    /**
         * 等待上传的文件push到上传队列中*/
    uploadWait(file) {
      this.updateFile(file, { uploadStatus: 'waiting' })
    },
    /**
         * 进度条更新*/
    processCb(file, percentage) {
      this.updateFile(file, { uploadProgress: percentage })
    },
    /**
         * 文件开始上传 */
    async uploading(file) {
      try {
        const that = this
        that.updateFile(file, { uploadStatus: 'uploading' })
        const fileInfo = await Upload.uploadFile.call(that, file, false, that.processCb)
        if (fileInfo) {
          this.success(fileInfo)
        } else {
          this.error(file)
        }
      } catch (err) {
        this.error(file)
      }
    },
    // 上传成功
    success(file) {
      this.uploadSuccess(file)
      this.upQueue.nextDo()
    },
    // 上传失败
    error(file) {
      this.uploadError(file)
      this.upQueue.nextDo()
    },
    /**
     * 比较两个数组是否包含相同的元素（不考虑顺序）
     * @param {Array} appNames 应用名称数组
     * @param {Array} softwareList 软件列表数组对象
     * @return {Boolean} 是否匹配
     */
    isSameSoftwareList(appNames, softwareList) {
      if (!appNames || !softwareList || appNames.length !== softwareList.length) {
        return false
      }
      // 提取softwareList中的所有softwareCode
      const softwareCodes = softwareList.map((item) => item.softwareCode)

      // 检查每个appName是否都在softwareCodes中
      const hasDifferentCode = appNames.some((name) => !softwareCodes.includes(name))

      return !hasDifferentCode
    },
  },
}
</script>

<style lang="less" scoped>
  /deep/ .uploader-dialog .el-dialog__body {
    padding:10px;
  }
  /deep/ .uploader-dialog .el-dialog__footer {
    padding:unset;
  }
  /deep/ .uploader-dialog .footer {
    padding: 10px 16px;
    border-top: 1px solid #e8e8e8;
    .left {
      float: left;
    }
  }
  .footer-tip {
    margin-top: 8px;
  }
  .uploader{
    text-align: left;
  }
  .uploader-tip{
    font-size: 12px;
    color: rgba(73, 95, 112, 0.4);
  }
  .el-upload__tip{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .red{
    color:@error-color;
  }
  .green{
    color:@success-color;
  }
  .yellow{
    color:@warning-color;
  }
  .dialog-title{
    font-size: 16px;
    margin-right: 14px;
  }
  .ft-12 {
    font-size: 16px;
  }
  .classify-container,.brand-container,.add-tag-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .label {
      padding: 0 12px;
    }
    .select {
      flex: 1;
    }
  }
  .upload-list {
    position: relative;
    margin-left: 4px;
    width:480px;
    background: #ffffff;
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid @border-color;

    .tabs{
      display: flex;
      .tab-item{
        min-width: 54px;
        padding: 0 2px 10px;
        cursor: pointer;
        position: relative;
        text-align: center;
        margin-right: 12px;
        &::after{
          position: absolute;
          content: '';
          bottom: 1px;
          left: 0;
          background-color: transparent;
          width: 100%;
          height: 2px;
        }
        &.active{
          &::after{
            background-color:@theme-color;
          }
          .total{
            background-color: @theme-color-hover;
            color: @theme-color;
          }
        }
        .total{
          margin-left: 8px;
          display: inline-block;
          height: 20px;
          min-width: 24px;
          background: @bg-grey-dark;
          border-radius: 50%;
        }
      }
    }

    &.list-fold {
      height: 40px;
      .upload-list-header{
        border-bottom: none;
      }
    }

    .upload-list-header {
      height: 40px;
      border-bottom: 1px solid #d9d9d9;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .upload-list-content{
      position: relative;
      background: #F8F8F8;
      padding: 8px 14px 35px;
      .upload-content-tip{
        position: absolute;
        bottom: 8px;
        left: 10px;
      }
    }
    .file-list{
      height: 222px;
      overflow-y: auto;
      .file{
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 48px;
        border: 1px solid #E6E6E6;
        background: #FFFFFF;
        border-radius: 2px;
        margin-bottom: 4px;
        &:last-child{
          margin-bottom: 0;
        }
        .name{
          width: 180px;
        }
        .size{
          width: 84px;
          color: @text-sub-gery;
        }
        .progress{
          box-sizing: border-box;
          width: 80px;
          padding: 0 10px 0 12px;
        }
      }
    }
    .empty-content{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .rotate-control {
      cursor: default;
    }

    .rotate-icon {
      display: inline-block;
      transform: rotate(180deg);
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      &.icon-fold {
        transform: rotate(0deg);
      }
    }
    .status-span{
      box-sizing: border-box;
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      i{
        margin-right:4px;
        font-size:12px;
      }
    }
    .success{
      color: @success-color;
    }
    .waiting{
      color: @warning-color;
    }
    .uploading{
      color: @text-blue;
    }
    .error{
      color: @error-color;
    }
    .strong-color {
      color: @text-tag-gery;
    }
  }

</style>
